var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconToolBarStopwatch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Icon_ToolBar_Stopwatch"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Widget Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 7",
    d: "M25.9087 35.5777C25.9087 33.3869 27.7402 23.1813 29.9995 23.1813C32.2588 23.1813 34.0903 33.3869 34.0903 35.5777C34.0903 37.7685 32.2588 39.5446 29.9995 39.5446C27.7402 39.5446 25.9087 37.7685 25.9087 35.5777Z",
    fill: "#40CFCA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 59",
    d: "M55.9078 34.0902C55.9078 48.399 44.3082 59.9987 29.9993 59.9987C15.6905 59.9987 4.09082 48.399 4.09082 34.0902C4.09082 19.7813 15.6905 8.18164 29.9993 8.18164C44.3082 8.18164 55.9078 19.7813 55.9078 34.0902ZM9.7871 34.0902C9.7871 45.2531 18.8364 54.3024 29.9993 54.3024C41.1622 54.3024 50.2116 45.2531 50.2116 34.0902C50.2116 22.9272 41.1622 13.8779 29.9993 13.8779C18.8364 13.8779 9.7871 22.9272 9.7871 34.0902Z",
    fill: "#40CFCA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 237",
    x: 41.481,
    y: 16.6177,
    width: 11.8606,
    height: 5.45442,
    rx: 2.72721,
    transform: "rotate(-45 41.481 16.6177)",
    fill: "#40CFCA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 238",
    x: 20.4541,
    width: 20.4541,
    height: 5.45442,
    rx: 2.72721,
    fill: "#40CFCA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToolBarStopwatch);
export default __webpack_public_path__ + "static/media/Icon_ToolBar_Stopwatch.50d7ce24f61f4dbd8db0dfc3858cd971.svg";
export { ForwardRef as ReactComponent };